import {
    SubTitle,
    Title,
    LoadingIndicator,
    Container,
    ShortId,
    Button,
} from 'src/ui/components';

import * as S from './styles';

const ReconnectFailed = () => {
    return (
        <Container>
            <LoadingIndicator />
            <Title>Reconnecting...</Title>
            <SubTitle>Sorry, we are unable to connect right now.</SubTitle>

            <S.Label>
                We will try to reconnect automatically, or you can refresh the
                screen. <br />
                If the issue persists, please call support at
            </S.Label>
            <S.Text>(866) 868-2146</S.Text>
            <Button type="button" onClick={() => window.location.reload()}>
                Refresh
            </Button>
            <ShortId />
        </Container>
    );
};

export default ReconnectFailed;
